// This Should be default State
const initialState = {
  isAuthorized: false,
  isLoaded: false,
  user: null,
};

export const user = (state = initialState, action) => {
  switch (action.type) {
    case "LOGIN":
      // localStorage.setItem('jwt', action.payload.token);
      // localStorage.setItem('refreshToken', action.payload.refreshToken);
      return {
        ...state,
        isAuthorized: true,
        isLoaded: true,
        user: action.payload,
      };
    case "CHANGE_OTPStatus":
      return {
        ...state,
        isAuthorized: true,
        isLoaded: true,
        user: { ...state.user, otp_enabled: action.payload.otp_enabled },
      };
    case "LOGOUT":
      // localStorage.removeItem('jwt');
      return {
        ...state,
        isAuthorized: false,
        isLoaded: true,
        user: null,
      };
    case "CHANGE_NAME":
      return {
        ...state,
        user: { ...state.user, firstName: action.payload.firstName, lastName: action.payload.lastName },
      };
    default:
      return state;
  }
};
